// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/restaurant/allergen.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_restaurant_food_types } from "./food_types_pb";

/**
 * Describes the file proto/model/feature/restaurant/allergen.proto.
 */
export const file_proto_model_feature_restaurant_allergen = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9mZWF0dXJlL3Jlc3RhdXJhbnQvYWxsZXJnZW4ucHJvdG8SBmNhcm1lbiJyCghBbGxlcmdlbhIrCg1mb29kX2NhdGVnb3J5GAEgASgOMhQuY2FybWVuLkZvb2RDYXRlZ29yeRIqCghzZXZlcml0eRgCIAEoDjIYLmNhcm1lbi5BbGxlcmdlblNldmVyaXR5Eg0KBW5vdGVzGAMgASgJQjtaOWdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvcmVzdGF1cmFudGIGcHJvdG8z", [file_proto_model_feature_restaurant_food_types]);

/**
 * Describes the message carmen.Allergen.
 * Use `create(AllergenSchema)` to create a new message.
 */
export const AllergenSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_restaurant_allergen, 0);

